import gql from 'graphql-tag';

const FETCH_NEAR_DEVICES = gql`
  query Query($latitude: String!, $longitude: String!) {
    fetchNearDevices(latitude: $latitude, longitude: $longitude) {
      latitude
      longitude
      deviceType
      deviceSerialNo
      broker
      hardwareVersion
      isBillable
      version
      status
      simNumber
      networkProvider
      stage
      firmwareVersion
    }
  }
`;

export default FETCH_NEAR_DEVICES;
